export enum ProductAttributeGroupType {
	Color = "Color",
}
